<template>
  <b-modal size="lg" v-model="is_show" :title="modalTitle" hide-footer @hide="onHide">
    <b-form @submit.prevent="onSubmit" @reset="onHide" v-loading="loading.detail">
      <b-form-group label="Title">
        <b-input
          v-model="form.title"
          placeholder="Input content title"
          type="text"/>
      </b-form-group>
       <b-form-group label="Name">
        <b-input
          v-model="form.name"
          placeholder="Input name"
          type="text"/>
      </b-form-group>
       <b-form-group label="Image">
          <b-form-file
            v-model="upload.image"
            :state="Boolean(upload.image)"
            class="mt-2 border-1 p-2"
            accept=".png, .jpg, .jpeg"
            @input="onChangeFile($event, 'image')"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <small class="text-warning"
            ><i>*Submit an image before creating a menu content</i></small
          ><br />
          <el-button @click="uploadImage" type="" size="small" plain round>
            Submit Image
          </el-button>
        </b-form-group>
        <b-form-group label="Current Image" v-if="type === 'edit'">
          <img :src="form.asset_menu" width="210"  hight="200" alt="Tabler" >
        </b-form-group>
        <b-form-group label="Target menu">
        <b-input
          v-model="form.target_menu"
          placeholder="Input target menu"
          type="text"/>
      </b-form-group>
      <b-form-group label="Is New">
        <el-select
          class="w-full"
          v-model="form.is_new"
          placeholder="Select is new">
          <el-option v-for="(item, index) in private_options" :value="item.value" :key="index" :label="item.label"/>
        </el-select>
      </b-form-group>
      <!-- <b-form-group label="Index">
        <b-input
          v-model="form.index"
          placeholder="Input content index"
          type="text"/>
      </b-form-group> -->
      <b-form-group label="Status">
        <el-select v-model="form.status" class="w-full" size="medium" placeholder="Select status">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </b-form-group>
       <b-form-group label="Color">
        <el-select v-model="form.color" class="w-full" size="medium" placeholder="Select status">
          <el-option v-for="item in enum_color" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </b-form-group>
      <div class="d-flex flex-row float-right">
        <el-button @click="onSubmit" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
        <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
      </div>
    </b-form>
  </b-modal>
</template>
<script>
import {
  UPLOAD_IMAGE,
} from "@/store/modules/channel";
import {
  GET_PARENTSECTION, ADD_ITEM_CONTENT, UPDATE_ITEM_CONTENT, DETAIL_ITEM_CONTENT,
} from '@/store/modules/app_content';
import popupErrorMessages from '@/library/popup-error-messages';
import ModalContentRecipient from './ModalContentRecipient.vue';
import emptyStateImage from '@/assets/images/empty-state.png';
import base64File from "@/library/base64File";
import imageCompress from "@/library/vue-image-compression";

export default {
  name: 'ModalSectionItemContent',
  components: {
    ModalContentRecipient,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'add',
    },
    selectedContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      data_image: null,
      image: null,
      image_base64: null,
      upload: {
        image: null,
      },
      list: [],
      total_rows: 0,
      emptyStateImage,
      is_show: false,
      loading: {
        submit: false,
        detail: false,
      },
      content_id: null,
      asset_menu: "",
      form: {
          name: "",
          title: "",
          asset_menu: "",
          target_menu: "",
          color: "",
          is_new: false, 
          index: 0,
          status: false,
      },
      selected_file: null,
      parent_section: [],
      statusOptions: [
          {
            value: true,
            label: 'Active',
          }, 
          {
            value: false,
            label: 'Inactive',
          },
        ],
      search_keyword: 'full_name',
      search: '',
      per_page: 10,
      page: 1,
      enum_color: [
        {
          value: 'null',
          label: 'Null',
        },
        {
          value: 'gradientBlue',
          label: 'Gradient Blue',
        },
        {
          value: 'gradientCyan',
          label: 'Gradient Cyan',
        },
        {
          value: 'gradientRed',
          label: 'Gradient Red',
        },
      ],
      private_options: [
         {
          value: true,
          label: 'True',
        },
        {
          value: false,
          label: 'False',
        },
      ]
    };
  },
  computed: {
    modalTitle() {
      return this.type === 'add' ? 'Add item' : 'Update item';
    },
    showingFromApp() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntilApp() {
      if (this.total_rows) {
        if (this.list_app.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },

  methods: {
    async uploadImage() {
      this.company_id = parseInt(this.company_id);
      try {
        const requestBody = {
          file_data: this.file_tmp,
          filename: "image-avatar",
          source: "vdashboard",
          product: "avatar",
          category: "system",
        };
        const response = await this.$store.dispatch(UPLOAD_IMAGE, {
          data: requestBody,
        });
        const { file_id, file_url } = response.data.rows;
        this.data_image = { file_id, file_url };
        localStorage.setItem("uploadedImage", JSON.stringify(this.data_image));
        this.file_tmp = "";
        this.$message({
          title: "Success",
          type: "success",
          message: "Upload success created",
        });

        this.getList();
      } catch (err) {
        console.error("Upload Image Error:", err.response?.data || err.message);
        popupErrorMessages(err.response?.data);
      }
    },
    async onChangeFile(event, target) {
      console.log("target image ==>", target);
      if (this.upload[target]) {
        const compressed = await imageCompress(this.upload[target]);
        this.upload[`${target}_base64`] = await base64File(compressed);
        this.file_tmp = this.upload[`${target}_base64`];
      }
    },
    async onSubmit() {
      this.loading.submit = true;
        const storedImage = localStorage.getItem("uploadedImage");
        const uploadedImage = storedImage ? JSON.parse(storedImage) : null;
        this.form.asset_menu = uploadedImage?.file_url || null;
      if (this.type === 'edit') {
        await this.updateContent();
      } else {
        await this.$store.dispatch(ADD_ITEM_CONTENT, this.form)
          .then(() => {
            this.$message({
              title: 'Success',
              type: 'success',
              message: 'Content successfully created',
            });
            this.$emit('afterSubmit');
          }).catch((err) => {
            popupErrorMessages(err.response.data);
          });
      }
      this.loading.submit = false;
    },
    async updateContent() {
      await this.$store.dispatch(UPDATE_ITEM_CONTENT, {
        _id: this.content_id,
        data: this.form,
      }).then(() => {
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Content successfully updated',
        });
        this.$emit('afterSubmit');
      }).catch((err) => {
        popupErrorMessages(err.response.data);
      });
    },
    onHide() {
      this.form = {
        name: '',
        title: '',
        asset_menu: '',
        target_menu: '',
        color: '',
        index: 0,
        status: false,
        is_new: false,
      };
      this.apply_to_user = false;
      this.$emit('onHide');
    },
    async getParentSection() {
      await this.$store.dispatch(GET_PARENTSECTION, {
        type: 'home',
      }).then(({ rows }) => {
        this.parent_section = rows;
      });
    },
    async getDetail(_id) {
      this.loading.detail = true;
      await this.$store.dispatch(DETAIL_ITEM_CONTENT, { _id })
      .then((res) => {
        const content = res?.rows;
        this.content_id = content?._id;
        this.form = {
          name: content?.name,
          title: content?.title,
          index: content.index,
          status: content.status,
          asset_menu: content.asset_menu,
          target_menu: content.target_menu,
          color: content.color,
          is_new: content.is_new,
        };
      })
      .catch((err) => {
      });
        this.loading.detail = false;
    },
  },
  watch: {
    show() {
      this.is_show = this.show;
      if (this.show) {
        if (this.type === 'edit') {
          this.getDetail(this.selectedContent._id);
        }
      }
    },
  },
};
</script>